import { urlTuition } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyCreateTuition, IQueryGetTuitions, ITuition } from '~/utils/interface/tuition';

export const tuitionApi = {
  getListTuitions(params: IQueryGetTuitions) {
    const url = `${urlTuition.getList}`;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITuition[]>>>(url, { params });
  },

  createTuition(body: IBodyCreateTuition) {
    const url = `${urlTuition.create}`;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};
